import { render, staticRenderFns } from "./patientMarsRep.vue?vue&type=template&id=b782e7e8&"
import script from "./patientMarsRep.vue?vue&type=script&lang=js&"
export * from "./patientMarsRep.vue?vue&type=script&lang=js&"
import style0 from "./patientMarsRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports